// extracted by mini-css-extract-plugin
export default {"returnLink":"SuccessScreenCommon_returnLink__oSAmt","returnButton":"SuccessScreenCommon_returnButton__DoTL-"};